import { giphyDarkCharcoal, giphyLightGrey } from '@giphy/colors'
import styled, { css } from 'styled-components'
import { ControlSize } from 'types'
import { fontSizeFromControlSize, heightFromControlSize } from 'utils'

export const Container = styled.div<{ $disabled: boolean; $size: ControlSize }>`
    align-items: flex-start;
    display: flex;
    height: ${({ $size }) => heightFromControlSize($size)}px;
    font-size: ${({ $size }) => fontSizeFromControlSize($size)}px;
    position: relative;

    &:before {
        background: ${giphyDarkCharcoal};
        bottom: 0;
        content: '';
        height: 1px;
        left: 0;
        position: absolute;
        width: 100%;
    }

    ${({ $disabled }) =>
        $disabled &&
        css`
            pointer-events: none;
        `}
`

export const Item = styled.button<{ $active: boolean }>`
    align-items: center;
    background: transparent;
    border: none;
    box-sizing: border-box;
    color: ${giphyLightGrey};
    cursor: pointer;
    display: flex;
    font-weight: bold;
    height: 100%;
    justify-content: center;
    line-height: normal;
    overflow: hidden;
    padding: 0 0.5em;
    position: relative;
    user-select: none;

    span {
        display: inline-block;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
    }

    &:active {
        opacity: 0.9;
    }

    ${({ $active }) =>
        $active &&
        css`
            border-bottom: 2px solid #fff;
            color: #fff;
            overflow: visible;
        `}
`
